export enum StateServiceName {
  PHARMACY,
  PROGRAM_GROUP,
  PROGRAM,
}
